module.exports = __webpack_public_path__ + "static/media/Google__G__Logo.svg.9817cf28.png";